<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} ẩm thực</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} ẩm thực</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} ẩm thực</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="5">
              <el-form-item label="Tên" prop="dich_vu.am_thuc.ten">
                <el-input v-model="mData.dataForm.dich_vu.am_thuc.ten" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="7">
              <el-form-item label="Địa chỉ" prop="diem_den_an_toan.du_lieu_khai_bao.user_dia_chi">
                <el-input v-model="mData.dataForm.diem_den_an_toan.du_lieu_khai_bao.user_dia_chi" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điện thoại" prop="diem_den_an_toan.du_lieu_khai_bao.user_dien_thoai">
                <el-input v-model="mData.dataForm.diem_den_an_toan.du_lieu_khai_bao.user_dien_thoai" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="diem_den_an_toan.du_lieu_khai_bao.email">
                <el-input v-model="mData.dataForm.diem_den_an_toan.du_lieu_khai_bao.email" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Website" prop="diem_den_an_toan.du_lieu_khai_bao.website">
                <el-input v-model="mData.dataForm.diem_den_an_toan.du_lieu_khai_bao.website" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điểm đến" prop="diem_den_an_toan.du_lieu_khai_bao.dia_chi_tinh_id">
                <el-select v-model="mData.dataForm.diem_den_an_toan.du_lieu_khai_bao.dia_chi_tinh_id"
                  :placeholder="aLang.c_select" disabled clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Dịch vụ" prop="diem_den_an_toan.du_lieu_khai_bao.nha_hang_dich_vu">
                <el-select v-model="mData.dataForm.diem_den_an_toan.du_lieu_khai_bao.nha_hang_dich_vu"
                  :disabled="mData.viewMode == 'detail'" clearable multiple filterable>
                  <el-option v-for="item in mData.dataDefault.listOptions" :key="item.id" :label="item.ten_vi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <!-- <b-col md="2" v-if="mData.ifHavePermission">
              <el-form-item label="Trạng thái" prop="duyet.duoc_duyet">
                <el-select
                  v-model="mData.dataForm.duyet.duoc_duyet"
                  disabled
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listAccept"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="4" lg="3" cols="12" v-for="item in mData.dataForm.dich_vu.link_dich_vu" :key="item.id">
              <el-form-item :label="'Link ' + (item.ten ? item.ten : '')" prop="">
                <el-input v-model="item.link" :disabled="mData.viewMode == 'accept'" @input="forceUpdateUI"
                  clearable></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" style="margin-bottom: 10px;">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="dich_vu.am_thuc.anh_hien_thi">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Mô tả" prop="dich_vu.am_thuc.mo_ta">
                <CknoimgComponent v-model="mData.dataForm.dich_vu.am_thuc.mo_ta"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'" @blur="handleBlur('dich_vu.am_thuc.mo_ta')">
                </CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Chi tiết" prop="dich_vu.am_thuc.chi_tiet">
                <CknoimgComponent v-model="mData.dataForm.dich_vu.am_thuc.chi_tiet"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('dich_vu.am_thuc.chi_tiet')"></CknoimgComponent>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda
              v-if="mData.viewMode == 'create'">{{ aLang.c_create }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda
              v-if="mData.viewMode == 'update'">{{ aLang.c_update }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import AmThucModel from './AmThucModel';
import ShareDDATModel from '@/views/admin/ShareModel/ShareDDATModel';
import ShareDichVuModel from '@/views/admin/ShareModel/ShareDichVuModel';
import ShareDonViCungCapModel from '@/views/admin/ShareModel/ShareDonViCungCapModel';
import DonViCungCapApi from '@/moduleApi/DonViCungCapApi';
import DichVuChoDuyetApi from '@/moduleApi/DichVuChoDuyetApi';
import DichVuAmThucApi from '@/moduleApi/DichVuAmThucApi';
import DDATApi from '@/moduleApi/DDATApi';
import NenTangDichVuApi from '@/moduleApi/NenTangDichVuApi';
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import ProvinceApi from '../../../moduleApi/ProvinceApi';
import MapboxComponent from "../../../component/MapboxComponent";
export default {
  components: {
    CknoimgComponent,
    MapboxComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "AmThucForm",
        dataDefault: {
          showMap: false,
          listProvince: [],
          listOptions: [],
          currentUser: {},
          listAccept: [
            {
              value: 0,
              label: 'Đã duyệt'
            },
            {
              value: 1,
              label: 'Chờ duyệt'
            },
            {
              value: 2,
              label: 'Từ chối'
            }
          ]
        },
        dataForm: {
          diem_den_an_toan: MethodService.copyObject(ShareDDATModel.dataForm),
          don_vi_cung_cap: MethodService.copyObject(ShareDonViCungCapModel.dataForm),
          dich_vu: MethodService.copyObject(ShareDichVuModel.dataForm)
        },
        dataFormOther: MethodService.copyObject(AmThucModel.dataFormOther),
        fileUploadOption: MethodService.copyObject(
          AmThucModel.dataFormOther.fileUploadOption
        ),
        validForm: AmThucModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        ifHavePermission: false,
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
      },
    };
  },
  async mounted() {
    let tinh_thanh = await ProvinceApi.list({
      limit: 1000
    });
    if (tinh_thanh.result) {
      this.mData.dataDefault.listProvince = tinh_thanh.result.map(item => {
        return { value: item.name, label: item.name }
      });
    }
  },
  async created() {
    this.fn_getDichVu();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      let diemDenAnToanRes = await DDATApi.list({
        filters: "nguoi_tao_id=$$user_id"
      });
      if (diemDenAnToanRes.result.length > 0) {
        this.mData.dataForm.diem_den_an_toan = diemDenAnToanRes.result[0];
        let donViCungCapRes = await DonViCungCapApi.findById(
          diemDenAnToanRes.result[0].id
        )
        if (donViCungCapRes.result) {
          this.mData.dataForm.don_vi_cung_cap = donViCungCapRes.result;
        }
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.mData.currentUser.id) {
      let dataFilter = {
        filters: 'nguoi_tao_id=' + this.mData.currentUser.id
      };
      let resDDAT = await DDATApi.list(dataFilter);
      this.mData.dataFormOther.id = resDDAT.result[0].id;
      await this.fn_getDataById(this.mData.dataFormOther.id);
      if (
        !this.mData.dataForm.id
      ) {
        this.mData.viewMode = "create";
        let nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Ẩm thực"
        });
        if (nen_tang_dich_vu.result) {
          for (let i = 0; i < nen_tang_dich_vu.result.length; i++) {
            nen_tang_dich_vu.result[i].link = "";
          }
        }
        this.mData.dataForm.dich_vu.link_dich_vu = nen_tang_dich_vu.result;
      } else {
        this.mData.ifHavePermission = true;
        this.mData.viewMode = "update";
      }
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            data.diem_den_an_toan_id = this.mData.dataForm.diem_den_an_toan.id;
            await DichVuChoDuyetApi.create(data);
            this.fn_resetForm();
            this.$router.push({ name: "Admin-ThongTinDDAT-detail" });
          }
          if (type === "update") {
            data.id = this.mData.dataFormOther.id;
            await DichVuChoDuyetApi.update(data);
            this.$router.push({
              name: "Admin-ThongTinDDAT-detail",
            });
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async fn_getDichVu() {
      let dichVuRes = await DichVuAmThucApi.list();
      if (dichVuRes.result) {
        this.mData.dataDefault.listOptions = dichVuRes.result.map(item => {
          return { value: item.id, label: item.ten_vi }
        });
      }
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        AmThucModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let am_thuc = await DichVuChoDuyetApi.findById(id);

      let resForm = {};
      if (am_thuc.result) {
        let resData = await this.fn_changeData(am_thuc.result);
        let resCongTyLuHanh = await DonViCungCapApi.list({
          filters: "id=" + am_thuc.result.diem_den_an_toan_id
        });
        this.mData.dataForm.am_thuc = resData;
        this.mData.dataForm.diem_den_an_toan = resCongTyLuHanh.result[0];
        let nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "am_thuc=Lưu trú"
        });
        if (nen_tang_dich_vu.result) {
          for (let i = 0; i < nen_tang_dich_vu.result.length; i++) {
            if (
              am_thuc.result.thong_tin_chung.link_dich_vu &&
              am_thuc.result.thong_tin_chung.link_dich_vu.find(x => x.id == nen_tang_dich_vu.result[i].id)
            ) {
              nen_tang_dich_vu.result[i].link = am_thuc.result.thong_tin_chung.link_dich_vu.find(x => x.id == nen_tang_dich_vu.result[i].id).link;
            } else {
              nen_tang_dich_vu.result[i].link = "";
            }
          }
        }
        this.mData.dataForm.dich_vu.link_dich_vu = nen_tang_dich_vu.result;
      }
      else if (!am_thuc.result) {
        this.$confirm(
          "Bạn chưa khai báo đầy đủ thông tin điểm đến, vui lòng khai báo trước khi truy cập tính năng này!",
          {
            confirmButtonText: LanguageService.lang.c_agree,
            showClose: false,
            showCancelButton: false,
            type: "warning",
          }
        )
          .then(() => {
            this.$router.push({
              name: "Admin-AmThucForm-create",
              params: { id: resForm.id },
            });
          })
      }
    },
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.dich_vu.am_thuc.anh_hien_thi = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("dich_vu.am_thuc.anh_hien_thi");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "AmThuc")
        .then(res => {
          this.mData.dataForm.dich_vu.am_thuc.anh_hien_thi = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("dich_vu.am_thuc.anh_hien_thi");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("dich_vu.am_thuc.anh_hien_thi");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  }
}
</script>
